export class Sharing {
    
    constructor(gudhub, req) {
      this.req = req;
      this.gudhub = gudhub;
      
    }

    async add(appId, userId, permission) {
        try {
            const form = {
                token: await this.gudhub.auth.getToken(),
                app_id: appId,
                user_id: userId,
                sharing_permission: permission
            };
            const response = await this.req.post({
                url: "/sharing/add",
                form,
            });
            return response;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    async update(appId, userId, permission) {
        try {
            const form = {
                token: await this.gudhub.auth.getToken(),
                app_id: appId,
                user_id: userId,
                sharing_permission: permission
            };
            const response = await this.req.post({
                url: "/sharing/update",
                form,
            });
            return response;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    async delete(appId, userId) {
        try {
            const form = {
                token: await this.gudhub.auth.getToken(),
                app_id: appId,
                user_id: userId
            };
            const response = await this.req.post({
                url: "/sharing/delete",
                form,
            });
            return response;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    async getAppUsers(appId) {
        try {
            const form = {
                token: await this.gudhub.auth.getToken(),
                app_id: appId
            };
            const response = await this.req.post({
                url: "/sharing/get-app-users",
                form,
            });
            return response;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    async addInvitation(guestsEmails, apps) {
        try {
            const form = {
                token: await this.gudhub.auth.getToken(),
                guests_emails: guestsEmails,
                apps
            };
            const response = await this.req.post({
                url: "/api/invitation/add",
                form,
            });
            return response;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

}
  